// extracted by mini-css-extract-plugin
export var banner = "_t2-0";
export var settingRow = "_t2-2";
export var titleIcon = "_t2-1";